export default class ButtonChangeRegions {
    constructor(button) {
        this.button = button;
        this.regionsModal = document.querySelector('.modal-regions-other');
        this.buttonClose = document.querySelector('.modal-regions-other-close');
        this.overlay = document.querySelector('.header__overlay-region');

        this.eventRegister();
    }
    eventRegister() {
        this.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.openRegioModal();
        });
        this.buttonClose.addEventListener('click', () => {
            this.closeRegionModal();
        });
        this.overlay.addEventListener('click', () => {
            this.closeRegionModal();
        });
    }
    openRegioModal() {
        this.regionsModal.style.display = 'flex';
        this.overlay.style.display = 'block';
    }
    closeRegionModal() {
        this.regionsModal.style.display = '';
        this.overlay.style.display = '';
    }
}
